<div *transloco="let t; read: 'collection-scene-select'" class="xi-modal__container">
  <h2 class="xi-modal__title kxi-text-center">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    <div class="">
      <xi-dropdown
        [(ngModel)]="selectedSceneId"
        [label]="t('select-scene')"
        [placeholder]="t('select-scene')"
        name="scenes"
        [stretch]="true"
        [data]="availableScenes"
      ></xi-dropdown>

      @if (!availableScenes.length) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="35"
            [width]="35"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      type="button"
      [text]="t('cancel')"
      fill="text"
      (onClick)="onCancel()"
    ></xi-default-button>

    <xi-default-button [text]="t('save')" (onClick)="onSave()"></xi-default-button>
  </div>
</div>
